import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { NFLookupCountry } from "../../../Shared/NewForms/NFLookupCountry";
import { NFLookupPosition } from "../../../Shared/NewForms/NFLookupPosition";
import { NFLookupBankAccount } from "../../../Shared/NewForms/NFLookupBankAccount";

const EmployeeDetailMain = () => {
    return (
        <div className={"panel-body tabs-menu-body main-content-body-right"}>
            <Row>
                <Col sm={6}>
                    <NFTextInput title={" Name"} fieldName={"firstName"} />
                </Col>
                <Col sm={6}>
                    <NFTextInput title={"Surname"} fieldName={"lastName"} />
                </Col>
                <Col sm={6}>
                    <NFDateInput title="HireDate" fieldName="hireDate" />
                </Col>
                <Col sm={6}>
                    <NFLookupInput
                        title="Gender"
                        fieldName={"gender"}
                        items={EnumHelper.GetGenderStatusTypeEnum()}
                    />
                </Col>
                <Col sm={6}>
                  <NFLookupCountry title="Country" fieldName="countryId"/>
                </Col>
                <Col sm={6}>
                  <NFLookupPosition title="Position" fieldName="positionId"/>
                </Col>
                <Col sm={6}>
                  <NFDateInput title="DateOfBirth" fieldName="dateOfBirth"/>
                </Col>
                <Col sm={6}>
                  <NFLookupBankAccount title="BankAccount" fieldName="bankAccountId"/>
                </Col>
                <Col sm={6}>
                    <NFLookupDivision title="Division" fieldName="divisionId"/>
                </Col>
            </Row>
        </div>
    );
};

export default EmployeeDetailMain;
